import React, { Component } from 'react';
import { Button, CustomInput, ListGroup, ListGroupItem } from 'reactstrap';
import PropTypes from 'prop-types';

const ListItem = ({ todos, toggleComplete, toggleSelect }) => (
    <ListGroupItem className="d-flex align-items-center">
        <CustomInput
            type="checkbox"
            id={todos.id}
            checked={todos.isSelect}
            onChange={() => toggleSelect(todos.id)}
        />
        <div className="mx-3">
            <h4> {todos.text} </h4>
            <p> {todos.time.toDateString()} </p>
        </div>
        <Button className="ml-auto my-2"
            color={todos.isComplete ? 'danger' : 'success'}
            onClick={() => toggleComplete(todos.id)}
        >
            {todos.isComplete ? 'Completed' : 'Running'}
        </Button>
    </ListGroupItem>
);

ListItem.propTypes = {
    todos: PropTypes.object.isRequired,
    toggleSelect: PropTypes.func.isRequired,
    toggleComplete: PropTypes.func.isRequired
};

export default class Listview extends Component {
    render() {
        return (
            <ListGroup>
                {this.props.todos.map(todo => (
                    <ListItem
                        key={todo.id}
                        todos={todo}
                        toggleSelect={this.props.toggleSelect}
                        toggleComplete={this.props.toggleComplete}
                    />
                ))}
            </ListGroup>
        );
    }
}

Listview.propTypes = {
    todos: PropTypes.object.isRequired,
    toggleSelect: PropTypes.func.isRequired,
    toggleComplete: PropTypes.func.isRequired
};